<template>
  <div class="page">
    <!-- 头部 -->
    <Header></Header>
    <!-- 合作伙伴 -->
    <div class="content">
      <div class="content_title">
        合作伙伴
      </div>
      <div class="company_content">
        <p>博雅数字基于社会责任及商业模式的理解，通过资源整合、技术研究和业务拓展，促进了政、产、 学、研、用各方的有机结合，逐步打造全产业链的联盟合作网络，进而实现与用户和合作伙伴的 快速共赢。</p>
        <p>
          <img src="../../assets/images/huoban.png" alt="">
        </p>      
      </div>
    </div>

    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "@/components/page/Footer.vue";
import Header from "@/components/page/Header.vue";
export default {
  components: {
    Footer,
    Header
  },
  data() {
    return {
      
    }
  },
  created() {
    
  },
  methods: {
    
  },
}
</script>
<style scoped>

.page .content {
  margin-top: 150px;
  padding: 0 32px;
  box-sizing: border-box;
  margin-bottom: 100px;
}
.page .content .content_title {
  height: 60px;
  color: #222;
  padding: 30px 0;
  box-sizing: border-box;
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 50px;
}
.page .content .company_content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.page .content .company_content p {
  line-height: 36px;
  font-size: 16px;
  font-weight: Normal;
  color: #666666;
  text-align: justify;
}
.page .content .company_content p img {
  width: 100%;
  margin: 0 auto;
}

</style>